import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";
import { simpleReducer } from "./utils";
import { isJiraContext } from "../api/api";

export const appList = [
  {
    app: "jsm",
    name: "Jira & Jira Service Management",
    description: "Sync Jira Customer, Organization, and Field Data to Sales CRM",
    imageUrl: "/static/images/jsm.svg",
    published: isJiraContext(),
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "hubspot",
    name: "Hubspot",
    description: "Convert Hubspot calendar meetings into new sales deals in Sales CRM",
    imageUrl: "/static/images/hubspot.png",
    published: true,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "mailchimp",
    name: "Mailchimp",
    description: "Sync contacts from Sales CRM to Mailchimp for marketing campaigns",
    imageUrl: "/static/images/mailchimp.svg",
    published: true,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "slack",
    name: "Slack",
    description: "Send Slack notifications for important sales events from Sales CRM",
    imageUrl: "/static/images/slack.svg",
    published: true,
    connected: false,
    hasSetting: false,
    requireAdmin: false,
  },
  {
    app: "import_csv",
    name: "Import CSV",
    description: "Import contact and account data from CSV files to Sales CRM",
    imageUrl: "/static/images/logo.svg",
    published: true,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "google",
    name: "Google",
    description: "Sync interactions, emails, and calendar tasks to Sales CRM",
    imageUrl: "/static/images/google.png",
    published: true,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "zapier",
    name: "Zapier Beta",
    description:
      "Zapier lets you connect Sales CRM with thousands of the most popular apps, so you can automate your work and have more time for what matters most—no code required.",
    imageUrl: "/static/images/zapier.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "mobile",
    name: "Mobile App",
    description:
      "Sales CRM app you can access your contacts, deal history and to-do's, create tasks and take meeting notes wherever you are - all changes are instantly synced to Sales CRM web app.",
    imageUrl: "/static/images/logo.svg",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "azure",
    name: "Outlook",
    description: "Send emails to customers using Microsoft Outlook from Sales CRM",
    imageUrl: "/static/images/outlook.png",
    published: true,
    connected: false,
    hasSetting: true,
    requireAdmin: false,
  },
  {
    app: "social_content_planner",
    name: "Social content planner",
    description:
      "Create and schedule marketing posts for Facebook, Threads, Instagram, Linkedin, X with Social Content by AI",
    imageUrl: "/static/images/ai-social.png",
    published: true,
    connected: false,
    hasSetting: false,
    requireAdmin: true,
  },
  {
    app: "facebook",
    name: "Facebook",
    description: "Create and schedule marketing posts for Facebook with Social Content by AI",
    imageUrl: "/static/images/facebook.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
  {
    app: "threads",
    name: "Threads",
    description: "Create and schedule marketing posts for Threads with Social Content by AI",
    imageUrl: "/static/images/threads.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
  {
    app: "instagram",
    name: "Instagram",
    description: "Create and schedule marketing posts for Instagram with Social Content by AI",
    imageUrl: "/static/images/instagram.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
  {
    app: "twitter",
    name: "X (Twitter)",
    description: "Create and schedule marketing posts for X (Twitter) with Social Content by AI",
    imageUrl: "/static/images/x.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
  {
    app: "linkedin",
    name: "LinkedIn",
    description: "Create and schedule marketing posts for LinkedIn with Social Content by AI",
    imageUrl: "/static/images/linkedin.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
  {
    app: "canva",
    name: "Canva",
    description: "Edit social media visuals via Canva in Sales CRM with our Social Content by AI",
    imageUrl: "/static/images/canva.png",
    published: false,
    connected: false,
    hasSetting: true,
    requireAdmin: true,
  },
];

const initialState = fromJS({
  rules: [],
  appLinks: appList,
  pending: true,
  rule: {
    events: [],
    actions: [],
    enabled: true,
  },
  source: [
    {
      value: "Advertisement",
      label: "Advertisement",
    },
    {
      value: "Employee Referral",
      label: "Employee Referral",
    },
    {
      value: "External Referral",
      label: "External Referral",
    },
    {
      value: "Partner",
      label: "Partner",
    },
    {
      value: "Public Relations",
      label: "Public Relations",
    },
    {
      value: "Seminar Internal",
      label: "Seminar Internal",
    },
    {
      value: "Seminar Partner",
      label: "Seminar Partner",
    },
    {
      value: "Trading Show",
      label: "Trading Show",
    },
    {
      value: "Web",
      label: "Web",
    },
    {
      value: "Word of mouth",
      label: "Word of mouth",
    },
    {
      value: "Hubspot",
      label: "Hubspot",
    },
    {
      value: "Jira",
      label: "Jira",
    },
    {
      value: "Other",
      label: "Other",
    },
  ],
  industry: [
    {
      value: "Agriculture",
      label: "Agriculture",
    },
    {
      value: "Apparel",
      label: "Apparel",
    },
    {
      value: "Banking",
      label: "Banking",
    },
    {
      value: "Biotechnology",
      label: "Biotechnology",
    },
    {
      value: "Chemicals",
      label: "Chemicals",
    },
    {
      value: "Communications",
      label: "Communications",
    },
    {
      value: "Construction",
      label: "Construction",
    },
    {
      value: "Consulting",
      label: "Consulting",
    },
    {
      value: "Education",
      label: "Education",
    },
    {
      value: "Electrics",
      label: "Electrics",
    },
    {
      value: "Engineering",
      label: "Engineering",
    },
    {
      value: "Environmental",
      label: "Environmental",
    },
    {
      value: "Finance",
      label: "Finance",
    },
    {
      value: "Food & Beverage",
      label: "Food & Beverage",
    },
    {
      value: "Healthcare",
      label: "Healthcare",
    },
    {
      value: "Hospitality",
      label: "Hospitality",
    },
    {
      value: "Insurance",
      label: "Insurance",
    },
    {
      value: "Machinery",
      label: "Machinery",
    },
    {
      value: "Media",
      label: "Media",
    },
    {
      value: "Not for Profit",
      label: "Not for Profit",
    },
    {
      value: "Other",
      label: "Other",
    },
    {
      value: "Recreation",
      label: "Recreation",
    },
    {
      value: "Retail",
      label: "Retail",
    },
    {
      value: "Shipping",
      label: "Shipping",
    },
    {
      value: "Technology",
      label: "Technology",
    },
    {
      value: "Telecommunications",
      label: "Telecommunications",
    },
    {
      value: "Transportation",
      label: "Transportation",
    },
    {
      value: "Utilities",
      label: "Utilities",
    },
  ],
  status: [
    {
      value: "Open",
      label: "Open",
      color: "text-blue-500",
    },
    {
      value: "Closed",
      label: "Closed",
      color: "text-neutral-500",
    },
  ],
  stage: [
    {
      value: "Won",
      label: "Won",
    },
    {
      value: "Unqualified",
      label: "Unqualified",
    },
    {
      value: "Lost",
      label: "Lost",
    },
  ],
  start: [
    {
      value: "NOW",
      label: "current date",
    },
    {
      value: "TODAY",
      label: "today",
    },
  ],
  finish: [
    {
      value: "NOW",
      label: "current date",
    },
    {
      value: "TODAY",
      label: "today",
    },
  ],
  bucketId: [],
  assignees: [],
  labels: [],
  salutation: [
    {
      value: "Mr",
      label: "Mr",
    },
    {
      value: "Mrs",
      label: "Mrs",
    },
    {
      value: "Miss",
      label: "Miss",
    },
    {
      value: "Ms",
      label: "Ms",
    },
    {
      value: "Dr",
      label: "Dr",
    },
    {
      value: "Others",
      label: "Others",
    },
  ],
  // Rule logs (activity / run history)
  ruleLogs: [],
  ruleLogsPage: 0,
  ruleLogsTotalPages: 0,
  ruleLogsTotalElements: 0,
  ruleLogDetail: null,
  ruleMetrics: null,
  pendingRuleLogs: false,
  pendingRuleLogDetail: false,
  pendingRuleMetrics: false,
});

const isConnected = (apps, app) => {
  const item = apps.find((item) => item.type == app);
  return item ? item.connected : false;
};

export const actions = {
  [ActionTypes.saveRule]: simpleReducer("rule"),
  [ActionTypes.getRule]: simpleReducer("rule"),
  [ActionTypes.getProject]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error, assignees: [] });
      }
      const { members = [] } = payload;
      const assignees = members.map((item) => ({
        value: item.accountId,
        label: item.displayName || item.name,
      }));
      const newState = {
        ...state.toJS(),
        assignees,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getLabels]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const { labels } = payload;
      const groups = labels.map((item) => ({
        value: item.id,
        label: item.name,
        color: item.color,
      }));
      const newState = {
        ...state.toJS(),
        labels: groups,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getBuckets]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const { buckets } = payload;
      const groups = buckets
        .sort((a, b) => a.order - b.order)
        .map((item) => ({ label: item.name, value: item.id }));
      const newState = {
        ...state.toJS(),
        bucketId: groups,
      };
      return fromJS(newState);
    },
  },

  [ActionTypes.getRules]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const newState = { ...state.toJS(), rules: payload };
      return fromJS(newState);
    },
  },
  [ActionTypes.getAppLinks]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const appLinks = appList.map((item) => {
        return {
          ...item,
          connected: isConnected(payload, item.app),
        };
      });
      const newState = { ...state.toJS(), appLinks };
      return fromJS(newState);
    },
  },
  [ActionTypes.setDefaultPageApp]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const newState = { ...state.toJS() };
      return fromJS(newState);
    },
  },
  [ActionTypes.deleteRule]: simpleReducer("rule"),
  [ActionTypes.setCurrentRule]: {
    next(state, { payload }) {
      const newState = {
        ...state.toJS(),
        rule: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.setPlatformProfile]: {
    next(state, { payload }) {
      if (!payload || !payload.platformId) {
        return state;
      }
      const currentProfiles = state.get("platformProfiles")?.toJS() || {};
      const newProfiles = {
        ...currentProfiles,
        [payload.platformId]: payload.profile,
      };
      const newState = {
        ...state.toJS(),
        platformProfiles: newProfiles,
      };
      return fromJS(newState);
    },
  },

  [ActionTypes.getRuleLogs]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ pendingRuleLogs: false, error, pending });
      }
      if (pending) {
        return state.merge({ pendingRuleLogs: true });
      }
      if (payload == null) {
        return state.merge({ pendingRuleLogs: false });
      }
      const content = payload.content ?? [];
      const totalPages = payload.totalPages ?? 0;
      const totalElements = payload.totalElements ?? 0;
      const number = payload.number ?? 0;
      return state.merge({
        pendingRuleLogs: false,
        ruleLogs: fromJS(content),
        ruleLogsPage: number,
        ruleLogsTotalPages: totalPages,
        ruleLogsTotalElements: totalElements,
      });
    },
  },
  [ActionTypes.getRuleLogDetail]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ pendingRuleLogDetail: false, error, pending });
      }
      if (pending) {
        return state.merge({ pendingRuleLogDetail: true, ruleLogDetail: null });
      }
      if (payload == null) {
        return state.merge({ pendingRuleLogDetail: false });
      }
      const detail = {
        ...payload,
        steps: Array.isArray(payload.steps) ? payload.steps : [],
        metrics: payload.metrics ?? {
          stepCount: 0,
          successCount: 0,
          failedCount: 0,
          totalDurationMs: 0,
          aiCostTotalUsd: null,
        },
      };
      return state.merge({
        pendingRuleLogDetail: false,
        ruleLogDetail: fromJS(detail),
      });
    },
  },
  [ActionTypes.getRuleMetrics]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ pendingRuleMetrics: false, error, pending });
      }
      if (pending) {
        return state.merge({ pendingRuleMetrics: true });
      }
      if (payload == null) {
        return state.merge({ pendingRuleMetrics: false });
      }
      return state.merge({
        pendingRuleMetrics: false,
        ruleMetrics: fromJS(payload),
      });
    },
  },
  [ActionTypes.setRuleLogDetail]: {
    next(state, { payload }) {
      return state.merge({
        ruleLogDetail: payload ? fromJS(payload) : null,
      });
    },
  },
  [ActionTypes.clearRuleLogs]: {
    next(state) {
      return state.merge({
        ruleLogs: fromJS([]),
        ruleLogsPage: 0,
        ruleLogsTotalPages: 0,
        ruleLogsTotalElements: 0,
        ruleLogDetail: null,
        ruleMetrics: null,
        pendingRuleLogs: false,
        pendingRuleLogDetail: false,
        pendingRuleMetrics: false,
      });
    },
  },
};

export const ruleReducer = handleActions(actions, initialState);
